import { EventTrackingHelper } from './event-tracking-helper';
import { submitEvent, submitMove, submitEventMerge } from '@otto-ec/tracking-bct';
import { trackEvent, trackEventMerge, trackMove } from '@otto-ec/nexus-registry/pdp/tracking';

export class EventTracking {
    constructor(private helper: EventTrackingHelper) {}

    public init(): void {
        trackEvent.assignFunction((dataContainer, action) => {
            const enhanced = this.helper.enhance(dataContainer, action);
            submitEvent(enhanced.data, enhanced.action);
        });

        trackEventMerge.assignFunction((mergeId, dataContainer, action) => {
            const enhanced = this.helper.enhance(dataContainer, action);
            submitEventMerge(mergeId, enhanced.data, enhanced.action);
        });

        trackMove.assignFunction((dataContainer, action) => {
            const enhanced = this.helper.enhance(dataContainer, action);
            submitMove(enhanced.data, enhanced.action);
        });
    }
}
